import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.nav`
    z-index: 1000;
    background: linear-gradient(135deg, #0f3460 0%, #16213e 100%) !important;
    border-bottom: 1px solid rgba(0, 212, 255, 0.2) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    position: relative !important;
    
    .navbar-nav {
        .nav-item {
            position: relative !important;
            z-index: 1001 !important;
            
            .nav-link {
                color: #e0e0e0 !important;
                
                &:hover {
                    color: #00d4ff !important;
                }
                
                .text-white {
                    color: #e0e0e0 !important;
                }
            }
        }
    }
    
    .dropdown-menu {
        z-index: 1050 !important;
        position: absolute !important;
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%) !important;
        border: 1px solid rgba(0, 212, 255, 0.2) !important;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
        border-radius: 12px !important;
        padding: 4px !important;
        min-width: 180px !important;
        gap: 0 !important;
        
        .dropdown-item {
            color: #e0e0e0 !important;
            border-radius: 8px !important;
            padding: 14px 16px !important;
            margin: 0 !important;
            transition: all 0.2s ease !important;
            display: flex !important;
            align-items: center !important;
            cursor: pointer !important;
            width: 100% !important;
            box-sizing: border-box !important;
            line-height: 1.5 !important;
            min-height: 48px !important;
            text-decoration: none !important;
            user-select: none !important;
            border: none !important;
            background: transparent !important;
            text-align: left !important;
            font-family: inherit !important;
            font-size: inherit !important;
            
            &:hover {
                background: rgba(0, 212, 255, 0.2) !important;
                color: #00d4ff !important;
                text-decoration: none !important;
                
                i {
                    color: #00d4ff !important;
                }
            }
            
            &:active,
            &:focus {
                background: rgba(0, 212, 255, 0.25) !important;
                color: #00d4ff !important;
                text-decoration: none !important;
                outline: none !important;
            }
            
            i {
                color: #00d4ff !important;
                margin-right: 12px !important;
                width: 18px !important;
                text-align: center !important;
                transition: all 0.2s ease !important;
                flex-shrink: 0 !important;
                pointer-events: none !important;
            }
            
            span {
                flex: 1;
                pointer-events: none !important;
            }
        }
    }
    
    .img-profile {
        border: 2px solid rgba(0, 212, 255, 0.3) !important;
        transition: all 0.3s ease !important;
        
        &:hover {
            border-color: rgba(0, 212, 255, 0.6) !important;
            box-shadow: 0 0 10px rgba(0, 212, 255, 0.3) !important;
        }
    }
    
    #sidebarToggleTop {
        color: #e0e0e0 !important;
        
        &:hover {
            color: #00d4ff !important;
        }
    }
`;

export const LogoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-right: auto;
    
    a {
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: transform 0.3s ease;
        
        &:hover {
            transform: scale(1.05);
        }
    }
    
    img {
        height: 50px;
        width: auto;
        object-fit: contain;
    }
`;

export const BackButton = styled(Link)`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e0e0e0 !important;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none !important;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: rgba(0, 212, 255, 0.15);
        border-color: rgba(0, 212, 255, 0.4);
        color: #00d4ff !important;
        transform: translateY(-1px);
    }

    @media (max-width: 768px) {
        span {
            display: none;
        }
        padding: 8px 10px;
    }
`;

export const SalesTitle = styled.h1`
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    i {
        color: #f29205;
        font-size: 26px;
        text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
    }
    
    @media (max-width: 768px) {
        font-size: 20px;
        
        i {
            font-size: 22px;
        }
    }
`;

export const CompanySelector = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 20px;
    
    @media (max-width: 768px) {
        margin-right: 10px;
    }
    
    label {
        color: #e0e0e0;
        font-size: 14px;
        font-weight: 500;
        margin: 0;
        white-space: nowrap;
        
        @media (max-width: 768px) {
            display: none;
        }
    }
    
    select {
        background: rgba(0, 212, 255, 0.1);
        border: 1px solid rgba(0, 212, 255, 0.3);
        border-radius: 8px;
        color: #ffffff;
        padding: 8px 12px;
        font-size: 14px;
        font-weight: 500;
        min-width: 200px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        @media (max-width: 768px) {
            min-width: 150px;
            font-size: 13px;
            padding: 6px 10px;
        }
        
        &:hover {
            background: rgba(0, 212, 255, 0.15);
            border-color: rgba(0, 212, 255, 0.5);
        }
        
        &:focus {
            outline: none;
            background: rgba(0, 212, 255, 0.2);
            border-color: rgba(0, 212, 255, 0.6);
            box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
        }
        
        option {
            background: #1a1a2e;
            color: #ffffff;
        }
    }
`;
